import { Report59Container } from "../../../containers/SupportSystem/Reports/Report59Container";
export function Report59Page() {
    return (
        <Report59Container />
    );

}